const header = document.querySelector("[data-header]");
const menuToggle = document.querySelector(".menu-toggle");

menuToggle?.addEventListener("click", () => {
  const isOpen = header.classList.toggle("nav-open");
  menuToggle.setAttribute("aria-expanded", String(isOpen));
});

document.querySelectorAll("[data-nav-category] > a").forEach((link) => {
  const category = link.closest("[data-nav-category]");

  category?.addEventListener("mouseenter", () => {
    if (!window.matchMedia("(max-width: 860px)").matches) {
      document.querySelectorAll("[data-nav-category].is-open").forEach((item) => {
        if (item !== category) item.classList.remove("is-open");
      });
      category.classList.add("is-open");
    }
  });

  category?.addEventListener("mouseleave", () => {
    if (!window.matchMedia("(max-width: 860px)").matches) {
      category.classList.remove("is-open");
    }
  });

  category?.addEventListener("pointerenter", () => {
    if (!window.matchMedia("(max-width: 860px)").matches) {
      document.querySelectorAll("[data-nav-category].is-open").forEach((item) => {
        if (item !== category) item.classList.remove("is-open");
      });
      category.classList.add("is-open");
    }
  });

  category?.addEventListener("pointerleave", () => {
    if (!window.matchMedia("(max-width: 860px)").matches) {
      category.classList.remove("is-open");
    }
  });

  link.addEventListener("click", (event) => {
    const isMobileNav = window.matchMedia("(max-width: 860px)").matches && header?.classList.contains("nav-open");
    const isOpen = category?.classList.contains("is-open");

    if (isMobileNav) {
      event.preventDefault();
      document.querySelectorAll("[data-nav-category].is-open").forEach((item) => {
        if (item !== category) item.classList.remove("is-open");
      });
      category?.classList.toggle("is-open", !isOpen);
      return;
    }

    if (!window.matchMedia("(max-width: 860px)").matches && category?.querySelector(".mega-menu")) {
      if (!isOpen) {
        event.preventDefault();
        document.querySelectorAll("[data-nav-category].is-open").forEach((item) => {
          if (item !== category) item.classList.remove("is-open");
        });
        category.classList.add("is-open");
      }
    }
  });
});

document.addEventListener("click", (event) => {
  if (!event.target.closest("[data-nav-category]")) {
    document.querySelectorAll("[data-nav-category].is-open").forEach((item) => item.classList.remove("is-open"));
  }
});

document.querySelectorAll("[data-hero-slider]").forEach((slider) => {
  const slides = [...slider.querySelectorAll("[data-hero-slide]")];
  const dots = [...slider.querySelectorAll("[data-hero-dot]")];
  if (slides.length <= 1) return;

  let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains("is-active")));
  let timer;

  const showSlide = (index) => {
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle("is-active", slideIndex === activeIndex);
    });
    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === activeIndex;
      dot.classList.toggle("is-active", isActive);
      dot.setAttribute("aria-current", String(isActive));
    });
  };

  const start = () => {
    timer = window.setInterval(() => showSlide(activeIndex + 1), 6000);
  };

  const stop = () => {
    if (timer) window.clearInterval(timer);
  };

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      stop();
      showSlide(Number(dot.dataset.heroDot || 0));
      start();
    });
  });

  slider.addEventListener("mouseenter", stop);
  slider.addEventListener("mouseleave", start);
  slider.addEventListener("focusin", stop);
  slider.addEventListener("focusout", start);

  showSlide(activeIndex);
  start();
});

document.querySelectorAll(".accordion-item").forEach((button) => {
  button.addEventListener("click", () => {
    const panel = button.nextElementSibling;
    const mark = button.querySelector("strong");
    const isOpen = panel.classList.toggle("is-open");
    mark.textContent = isOpen ? "-" : "+";
  });
});

document.querySelectorAll("[data-brand-scroll]").forEach((button) => {
  button.addEventListener("click", () => {
    const carousel = button.closest(".brand-carousel");
    const strip = carousel?.querySelector("[data-brand-strip]");
    if (!strip) return;

    const direction = button.dataset.brandScroll === "prev" ? -1 : 1;
    strip.scrollBy({
      left: direction * Math.max(strip.clientWidth * 0.72, 180),
      behavior: "smooth",
    });
  });
});

document.querySelectorAll(".shopify-policy__body .rte").forEach((policyBody) => {
  const encodedHtml = policyBody.innerHTML;
  const textarea = document.createElement("textarea");
  textarea.innerHTML = encodedHtml.replace(/<br\s*\/?>/gi, "\n");
  const decodedHtml = textarea.value;

  if (/<\/?(h1|h2|h3|p|ul|ol|li)\b/i.test(decodedHtml)) {
    policyBody.innerHTML = decodedHtml;
  }

  const legacyBrand = ["Black", "line Apparel"].join("");
  policyBody.innerHTML = policyBody.innerHTML
    .replace(new RegExp(legacyBrand, "g"), "Aryon Apparel")
    .replace(new RegExp(legacyBrand.toUpperCase(), "g"), "ARYON APPAREL");
  policyBody.innerHTML = policyBody.innerHTML.replace(/<p>\s*Phone:\s*\[your phone number\]\s*<\/p>/i, "");
  policyBody.classList.add("policy-rte");
});

const bindProductThumbs = (scope = document) => {
  scope.querySelectorAll("[data-product-thumb]").forEach((thumb) => {
    if (thumb.dataset.thumbReady === "true") return;
    thumb.dataset.thumbReady = "true";

    thumb.addEventListener("click", (event) => {
      const productTemplate = thumb.closest(".product-template");
      const mainImage = productTemplate?.querySelector("[data-product-main-image]");
      if (!mainImage || !thumb.dataset.productThumbImage) return;

      event.preventDefault();
      mainImage.src = thumb.dataset.productThumbImage;
      mainImage.removeAttribute("srcset");
      mainImage.alt = thumb.dataset.productThumbAlt || mainImage.alt;

      productTemplate.querySelectorAll("[data-product-thumb]").forEach((item) => {
        const isSelectedThumb = item === thumb;
        item.classList.toggle("is-selected", isSelectedThumb);
        item.setAttribute("aria-current", String(isSelectedThumb));
      });
    });
  });
};

const SWATCH_COLOURS = {
  "13% marle": "#b8b8b8",
  "alabaster": "#eee9dd",
  "all black": "#111111",
  "all navy": "#17243b",
  "amethyst": "#8d6caf",
  "anti fog clear": "rgba(226, 239, 244, .72)",
  "apple": "#76a942",
  "arctic": "#b8d8e8",
  "ash grey": "#cacccf",
  "ash": "#cacccf",
  "athletic htr.g": "#a8aaac",
  "aqua": "#52c7cf",
  "army": "#5f6650",
  "asphalt": "#55575a",
  "azalea": "#e879af",
  "bay": "#6f8f7b",
  "beige": "#d9cfb5",
  "berry": "#8c3f5d",
  "black": "#111111",
  "blossom": "#efb4c4",
  "blush": "#d8a5a5",
  "blue dusk": "#53627b",
  "blue": "#3274b9",
  "bone": "#e8dfcf",
  "bottle": "#153d2b",
  "brown": "#8d3c32",
  "burgundy": "#6e1f34",
  "brick": "#9b4f46",
  "butter": "#efd36c",
  "camel": "#b88d5a",
  "camo": "linear-gradient(135deg, #39442e 0 25%, #73724d 25% 50%, #4f5637 50% 75%, #a08b5c 75%)",
  "cardinal": "#9c2635",
  "cat": "linear-gradient(135deg, #c4a079 0 50%, #4a443e 50%)",
  "celadon": "#a8c3aa",
  "chambray": "#8faabd",
  "charcoal": "#45484b",
  "check": "conic-gradient(#45484b 25%, #eeeeee 0 50%, #45484b 0 75%, #eeeeee 0)",
  "cheeky pets": "linear-gradient(135deg, #d6b58d 0 33%, #788e9d 33% 66%, #8b6856 66%)",
  "cherry": "#b7253c",
  "cherry red": "#b91f35",
  "chili": "#8d342f",
  "chocolate": "#49392b",
  "cinnamon": "#a25f42",
  "citrine": "#d2a62a",
  "citrus": "#efb62f",
  "claret": "#6f263d",
  "clay": "#b87960",
  "clear": "rgba(226, 239, 244, .72)",
  "cobalt": "#2457a5",
  "cocoa": "#765344",
  "combat": "#6f7151",
  "copper": "#ad6845",
  "coral": "#ee786f",
  "cranberry": "#9c2947",
  "cream": "#f2ead8",
  "crimson": "#a6192e",
  "cyan": "#18a9c1",
  "daisy": "#efd447",
  "dark grey": "#55595d",
  "dark heather": "#5d6063",
  "dark navy": "#101d35",
  "deep royal": "#1c57a6",
  "deep cobalt": "#254f91",
  "denim": "#58758b",
  "denim marle": "#7b8d9a",
  "desert": "#c6ad81",
  "diesel": "#4d5152",
  "dino": "linear-gradient(135deg, #6f8a54 0 50%, #b7a46f 50%)",
  "electric blue": "#1578c8",
  "eggplant": "#4c304d",
  "emerald": "#16805b",
  "espresso": "#49352d",
  "fluoro lime": "#c8e52b",
  "fluoro orange": "#ff681f",
  "fluoro yellow": "#f4ed24",
  "forest green": "#00503c",
  "forest": "#00503c",
  "fern": "#617c56",
  "fuchsia": "#cf3d86",
  "fuschia": "#cf3d86",
  "garnet": "#7f2638",
  "gold": "#feb034",
  "grape": "#6b4d71",
  "graphite": "#555a60",
  "gravel": "#898781",
  "green": "#2f6f3e",
  "grey marle": "#a9aaac",
  "gray marle": "#a9aaac",
  "grey": "#9d9d9d",
  "gray": "#9d9d9d",
  "gunmetal": "#4f5961",
  "heliconia": "#dc226f",
  "hemp": "#a99b7d",
  "hot pink": "#e84890",
  "indigo": "#3f5d79",
  "ink": "#263548",
  "iris": "#6b62a7",
  "ivory": "#f3eedf",
  "jade": "#2f8d77",
  "jade dome": "#2b6f64",
  "kelly green": "#168447",
  "kelly": "#168447",
  "khaki": "#b7a26a",
  "kiwi": "#93c05c",
  "lapis": "#315c9c",
  "latte": "#b99b7b",
  "lavender": "#b9a7d4",
  "lieutenant": "#6c7058",
  "light blue": "#bcdbf3",
  "light grey": "#d1d2d4",
  "light pink": "#fbc9dd",
  "lime": "#9fd28a",
  "lilac": "#c3a9cf",
  "magenta": "#c43b78",
  "maroon": "#6e1f34",
  "marine": "#294d65",
  "marshmallow": "#f3ede5",
  "mauve": "#a77483",
  "mid blue": "#3d75a5",
  "midnight navy": "#15243b",
  "midnight": "#263349",
  "mint": "#a8d7c7",
  "mustard": "#c99b2d",
  "mushroom": "#a89d90",
  "natural": "#ded6c1",
  "navy": "#17243b",
  "neon green": "#9be331",
  "neon lemon": "#d9f23a",
  "neon orange": "#ff6b22",
  "none": "#eeeeee",
  "ochre": "#b98526",
  "ocean": "#3f7d8c",
  "ocean marle": "#7396a0",
  "off white": "#eee9dd",
  "olive": "#69714a",
  "orange": "#f47a20",
  "orchid": "#b784af",
  "paprika": "#b45139",
  "paragon": "#536d83",
  "peach": "#f2b49b",
  "pepper": "#4b4a4a",
  "petrol": "#315c63",
  "pewter": "#777c80",
  "pink": "#e88bad",
  "pistachio": "#b7c99a",
  "platinum": "#bfc1c2",
  "puppies": "linear-gradient(135deg, #b98d62 0 33%, #ece3d3 33% 66%, #6f5948 66%)",
  "purple": "#6d4aa2",
  "raspberry": "#b72f63",
  "red": "#b3262e",
  "reflective silver": "#c8cbd0",
  "rose": "#c97482",
  "royal": "#1c57a6",
  "rust": "#a55032",
  "safety green": "#d3de38",
  "safety orange": "#f47a20",
  "safety yellow": "#f2e827",
  "sage": "#9ca98d",
  "sand": "#d7c8a6",
  "sapphire": "#0087c1",
  "sea blue": "#477f99",
  "seafoam": "#9bc7b8",
  "silver": "#c4c7ca",
  "sky": "#75aadb",
  "slate": "#66717c",
  "smoke": "#76797b",
  "snow marle": "#dedfe0",
  "sugar land": "#e7bfd0",
  "steel": "#667985",
  "stone": "#aaa38f",
  "tan": "#b9966e",
  "taupe": "#9a8978",
  "teal": "#16858a",
  "terracotta": "#b86650",
  "turquoise": "#38aeb4",
  "violet": "#7d5aa8",
  "watermelon": "#df6c77",
  "wheat": "#ddc89b",
  "white": "#ffffff",
  "wine": "#713148",
  "yellow": "#ffd21f",
};

const normaliseSwatchValue = (value) => value
  .toLowerCase()
  .replace(/[_-]+/g, " ")
  .replace(/\s+/g, " ")
  .trim();

const swatchAliases = Object.keys(SWATCH_COLOURS).sort((a, b) => b.length - a.length);

const resolveSwatchPart = (value) => {
  const normalised = normaliseSwatchValue(value);
  if (SWATCH_COLOURS[normalised]) return SWATCH_COLOURS[normalised];
  const alias = swatchAliases.find((name) => normalised.includes(name));
  return alias ? SWATCH_COLOURS[alias] : "";
};

const bindColorSwatches = (scope = document) => {
  scope.querySelectorAll(".option-swatch[data-swatch-value]").forEach((button) => {
    const rawValue = button.dataset.swatchValue || "";
    const handle = normaliseSwatchValue(rawValue).replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    const mappedVariable = getComputedStyle(document.documentElement).getPropertyValue(`--swatch-${handle}`).trim();
    const parts = rawValue.split(/\s*(?:\/|\+|&)\s*/).filter(Boolean);
    const colours = [...new Set(parts.map(resolveSwatchPart).filter(Boolean))].slice(0, 3);
    let background = mappedVariable;

    if (!background && colours.length === 1) {
      [background] = colours;
    } else if (!background && colours.length > 1) {
      const stop = 100 / colours.length;
      const stops = colours.flatMap((colour, index) => [
        `${colour} ${Math.max(0, index * stop)}%`,
        `${colour} ${Math.min(100, (index + 1) * stop)}%`,
      ]);
      background = `linear-gradient(90deg, ${stops.join(", ")})`;
    }

    button.classList.toggle("is-pattern-swatch", !background);
    button.classList.toggle("is-light-swatch", /white|ivory|bone|cream|natural|sand|ash|light grey|light gray/i.test(rawValue));
    button.style.setProperty("--swatch-color", background || "#d8d8d8");
  });
};

const linkedProductTemplateCache = new Map();

const getLinkedProductSectionUrl = (url, sectionId) => {
  const sectionUrl = new URL(url, window.location.origin);
  if (sectionId) sectionUrl.searchParams.set("section_id", sectionId);
  return sectionUrl.toString();
};

const getLinkedProductTemplate = async (url, sectionId) => {
  const sectionUrl = getLinkedProductSectionUrl(url, sectionId);
  const cachedTemplate = linkedProductTemplateCache.get(sectionUrl);
  if (cachedTemplate) return cachedTemplate.cloneNode(true);

  const response = await fetch(sectionUrl, {
    credentials: "same-origin",
    headers: { "X-Requested-With": "XMLHttpRequest" },
  });
  if (!response.ok) throw new Error("Variant request failed");

  const html = await response.text();
  const nextDocument = new DOMParser().parseFromString(html, "text/html");
  const nextTemplate = nextDocument.querySelector(".product-template");
  if (!nextTemplate) throw new Error("Variant template missing");

  linkedProductTemplateCache.set(sectionUrl, nextTemplate);
  return nextTemplate.cloneNode(true);
};

const bindLinkedProductOptions = (scope = document) => {
  scope.querySelectorAll("[data-product-form]").forEach((form) => {
    if (form.dataset.linkedOptionsReady === "true") return;
    if (form.querySelector("[data-variant-select]")) return;
    const linkedOptions = [...form.querySelectorAll('a.option-button[href*="variant="]')];
    if (!linkedOptions.length) return;

    form.dataset.linkedOptionsReady = "true";

    linkedOptions.forEach((button) => {
      const prefetchLinkedOption = () => {
        if (button.dataset.variantPrefetchReady === "true") return;
        if (button.getAttribute("aria-disabled") === "true" || button.classList.contains("is-disabled")) return;

        const url = button.href;
        if (!url) return;

        const productTemplate = form.closest(".product-template");
        const sectionId = productTemplate?.dataset.productSectionId || "";
        button.dataset.variantPrefetchReady = "true";
        getLinkedProductTemplate(url, sectionId).catch(() => {});
      };

      button.addEventListener("pointerenter", prefetchLinkedOption, { once: true });
      button.addEventListener("focus", prefetchLinkedOption, { once: true });

      button.addEventListener("click", async (event) => {
        if (button.getAttribute("aria-disabled") === "true" || button.classList.contains("is-disabled")) {
          event.preventDefault();
          return;
        }

        const url = button.href;
        if (!url) return;

        event.preventDefault();
        const productTemplate = form.closest(".product-template");
        const sectionId = productTemplate?.dataset.productSectionId || "";
        productTemplate?.classList.add("is-loading-variant");

        try {
          const nextTemplate = await getLinkedProductTemplate(url, sectionId);
          if (!productTemplate || !nextTemplate) throw new Error("Variant template missing");

          productTemplate.replaceWith(nextTemplate);
          window.history.replaceState({}, "", url);
          bindColorSwatches(nextTemplate);
          bindLinkedProductOptions(nextTemplate);
          bindProductThumbs(nextTemplate);
        } catch (error) {
          window.location.href = url;
        }
      });
    });
  });
};

document.addEventListener("click", (event) => {
  const stepButton = event.target.closest("[data-quantity-step]");
  if (!stepButton) return;

  const control = stepButton.closest(".quantity-control");
  const input = control?.querySelector('input[name="quantity"]');
  if (!input) return;

  const step = Number(stepButton.dataset.quantityStep || 0);
  const minimum = Number(input.min || 1);
  const current = Number(input.value || minimum);
  input.value = String(Math.max(minimum, current + step));
  input.dispatchEvent(new Event("change", { bubbles: true }));
});

document.addEventListener("submit", async (event) => {
  const form = event.target.closest("[data-product-form]");
  if (!form) return;

  event.preventDefault();
  const submitButton = form.querySelector('[type="submit"]');
  const feedback = form.querySelector("[data-product-cart-feedback]");
  const actions = form.querySelector("[data-product-cart-actions]");
  const originalButtonText = submitButton?.textContent || "Add to cart";

  if (submitButton) {
    submitButton.disabled = true;
    submitButton.textContent = "Adding…";
  }
  if (feedback) feedback.textContent = "";
  if (actions) actions.hidden = true;

  try {
    const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: new FormData(form),
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(result.description || "This item could not be added to the cart.");

    if (feedback) feedback.textContent = "Added to cart. You can continue shopping or review your cart.";
    if (actions) actions.hidden = false;

    const cartResponse = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, {
      headers: { "Accept": "application/json" },
    });
    if (cartResponse.ok) {
      const cart = await cartResponse.json();
      document.querySelectorAll('a.header-action[href*="/cart"]').forEach((link) => {
        link.textContent = `Cart ${cart.item_count}`;
      });
    }
  } catch (error) {
    if (feedback) feedback.textContent = error.message || "This item could not be added to the cart.";
  } finally {
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.textContent = originalButtonText;
    }
  }
});

document.querySelectorAll("[data-product-form]").forEach((form) => {
  const select = form.querySelector("[data-variant-select]");
  const status = form.querySelector("[data-variant-status]");
  const groups = [...form.querySelectorAll("[data-option-index]")];
  const productTemplate = form.closest(".product-template");
  const mainImage = productTemplate?.querySelector("[data-product-main-image]");
  const productPrice = productTemplate?.querySelector("[data-product-price]");
  const productAvailability = productTemplate?.querySelector("[data-product-availability]");
  if (!select || !groups.length) return;

  const optionCount = Number(form.dataset.optionCount || groups.length);
  let selected = Array(optionCount).fill("");

  groups.forEach((group) => {
    const index = Number(group.dataset.optionIndex);
    selected[index] = group.querySelector(".option-button.is-selected")?.dataset.optionValue || "";
  });

  const fixedOptions = [...form.querySelectorAll("[data-fixed-option-index]")];
  fixedOptions.forEach((input) => {
    selected[Number(input.dataset.fixedOptionIndex)] = input.value;
  });

  const variantOptions = [...select.options].map((option) => {
    return {
      option,
      values: option.dataset.options?.split("||").map((value) => value.trim()) || [],
      disabled: option.disabled,
      price: Number(option.dataset.price || 0),
      image: option.dataset.variantImage || "",
      imageAlt: option.dataset.variantImageAlt || "",
    };
  });

  // Keep the linked variant, including a sold-out one, instead of resetting
  // Google/Shopping links to the first size and colour after page load.
  const compatibleVariants = variantOptions.filter((item) => fixedOptions.every((input) => {
    return item.values[Number(input.dataset.fixedOptionIndex)] === input.value;
  }));
  const linkedVariantId = new URLSearchParams(window.location.search).get("variant");
  const initialVariant = compatibleVariants.find((item) => item.option.value === linkedVariantId)
    || compatibleVariants.find((item) => item.option.value === select.value)
    || compatibleVariants.find((item) => !item.disabled)
    || compatibleVariants[0];
  if (initialVariant) selected = [...initialVariant.values];

  const formatMoney = (cents) => {
    return `$${(Math.round(cents) / 100).toFixed(2)}`;
  };

  const updateBulkPrices = (price) => {
    form.querySelectorAll("[data-bulk-price]").forEach((priceNode) => {
      const discount = Number(priceNode.dataset.discount || 100);
      priceNode.textContent = formatMoney((price * discount) / 100);
    });
  };

  const updateProductPrice = (price) => {
    if (!productPrice) return;
    const label = productPrice.querySelector("span")?.outerHTML || "<span>Price</span>";
    productPrice.innerHTML = `${label} ${formatMoney(price)}`;
  };

  const updateProductAvailability = (available) => {
    if (!productAvailability) return;
    productAvailability.textContent = available ? "In stock" : "Unavailable";
    productAvailability.classList.toggle("is-unavailable", !available);
  };

  const updateProductImage = (item) => {
    if (!mainImage || !item?.image) return;
    mainImage.src = item.image;
    mainImage.removeAttribute("srcset");
    mainImage.alt = item.imageAlt || mainImage.alt;

    productTemplate?.querySelectorAll("[data-product-thumb]").forEach((thumb) => {
      const isSelectedThumb = thumb.dataset.productThumbImage === item.image;
      thumb.classList.toggle("is-selected", isSelectedThumb);
      thumb.setAttribute("aria-current", String(isSelectedThumb));
    });
  };

  const applySelectedState = () => {
    groups.forEach((group) => {
      const index = Number(group.dataset.optionIndex);
      group.querySelectorAll(".option-button").forEach((button) => {
        const isSelected = button.dataset.optionValue === selected[index];
        button.classList.toggle("is-selected", isSelected);
        button.setAttribute("aria-pressed", String(isSelected));
      });
    });
  };

  const hasMatch = (values) => {
    return variantOptions.some((item) => {
      return !item.disabled && item.values.every((value, index) => !values[index] || value === values[index]);
    });
  };

  const refreshAvailability = () => {
    groups.forEach((group) => {
      const index = Number(group.dataset.optionIndex);
      group.querySelectorAll(".option-button").forEach((button) => {
        const trial = [...selected];
        trial[index] = button.dataset.optionValue;
        const available = hasMatch(trial);
        button.disabled = !available;
        button.classList.toggle("is-disabled", !available);
        button.setAttribute("aria-disabled", String(!available));
      });
    });
  };

  const updateVariant = (notifyChange = true) => {
    const match = variantOptions.find((item) => {
      return item.values.every((value, index) => value === selected[index]);
    });

    if (match) {
      select.value = match.option.value;
      if (notifyChange) select.dispatchEvent(new Event("change", { bubbles: true }));
      updateProductPrice(match.price);
      updateBulkPrices(match.price);
      updateProductImage(match);
      updateProductAvailability(!match.disabled);
      if (status) status.textContent = match.disabled ? "This option is currently unavailable." : "";
      form.querySelector('[type="submit"]').disabled = match.disabled;
    } else {
      updateProductAvailability(false);
      if (status) status.textContent = "This combination is not available.";
      form.querySelector('[type="submit"]').disabled = true;
    }

    const artworkInput = form.querySelector("[data-printing-artwork]");
    const artworkStatus = form.querySelector("[data-printing-artwork-status]");
    const brandingGroup = groups.find((group) => {
      const name = group.dataset.optionName || "";
      return name.includes("branding") || name.includes("printing");
    });
    if (artworkInput && brandingGroup) {
      const brandingValue = selected[Number(brandingGroup.dataset.optionIndex)] || "";
      const needsArtwork = brandingValue.toLowerCase() !== "unbranded";
      artworkInput.required = needsArtwork;
      if (artworkStatus) {
        artworkStatus.textContent = needsArtwork
          ? "Artwork is required for this branding option."
          : "No artwork is needed for an unbranded order.";
      }
    }
    refreshAvailability();
  };

  applySelectedState();

  select.addEventListener("change", () => {
    const item = compatibleVariants.find((variant) => variant.option.value === select.value);
    if (!item || item.values.every((value, index) => value === selected[index])) return;
    selected = [...item.values];
    applySelectedState();
    updateVariant(false);
  });

  groups.forEach((group) => {
    const index = Number(group.dataset.optionIndex);
    group.querySelectorAll(".option-button").forEach((button) => {
      button.addEventListener("click", () => {
        if (button.disabled) return;
        group.querySelectorAll(".option-button").forEach((item) => {
          item.classList.remove("is-selected");
          item.setAttribute("aria-pressed", "false");
        });
        button.classList.add("is-selected");
        button.setAttribute("aria-pressed", "true");
        selected[index] = button.dataset.optionValue;
        updateVariant();
      });
    });
  });

  updateVariant();
});

bindLinkedProductOptions();
bindProductThumbs();
bindColorSwatches();
